import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-field-unverified-text',
  standalone: true,
  template: ` <div class="row align-items-center mb-3 mt-neg-2">
    <div class="col-auto pe-0">
      <div class="warning-icon">
        <i class="iconoir-warning-circle"></i>
      </div>
    </div>
    <div class="col">{{ content }}</div>
  </div>`,
})
export class FieldUnverifiedTextComponent {
  @Input() content!: string;
}
